/**
 * BookingDetailsDialogController
 * Controller for managing vehicle booking details dialog
 */
function BookingDetailsDialogController() {
    this.constructor.apply(this, arguments);
}

/**
 * Dependency injection for the controller.
 */
BookingDetailsDialogController.$inject = ['$scope', '$state', 'VehicleBookingService', '$stateParams', '$message', '$Loading', 'DeviceService'];

/**
 * Define the prototype methods and properties of the controller.
 */
BookingDetailsDialogController.prototype = {
    /**
     * Constructor for the BookingDetailsDialogController.
     * Initializes the controller with the required dependencies and loads booking data if an ID is provided.
     *
     * @param $scope {IScope} - AngularJS $scope object.
     * @param $state {ui.IStateService} - AngularJS state service for state transitions.
     * @param VehicleBookingService {VehicleBookingService} - Service for managing vehicle bookings.
     * @param $stateParams {ui.IStateParamsService} - Service for accessing state parameters.
     * @param $message {$message} - Service for displaying messages to the user.
     * @param $Loading {$Loading} - Service for managing loading states.
     * @param DeviceService {DeviceService} - Service for managing device-related functionalities.
     */
    constructor($scope, $state, VehicleBookingService, $stateParams, $message, $Loading, DeviceService) {
        this.$scope = $scope;
        this.$state = $state;
        this.vehicleBookingService = VehicleBookingService;
        this.$stateParams = $stateParams;
        this.$message = $message;
        this.$Loading = $Loading;
        this.deviceService = DeviceService;

        /**
         * @type {IVehicleBooking} - The current booking item being managed.
         */
        this.item = null;

        // If an ID is provided in the state parameters, load the booking data.
        if (this.$stateParams.id) {
            this.loadData(this.$stateParams.id);
        }
        this.deviceService.onGoBackButton(this.$scope, this.goBack.bind(this));
    },

    /**
     * Navigate back to the previous state.
     * Retrieves the previous state and its parameters from the state parameters.
     */
    goBack() {
        let params = {};
        if (this.$stateParams.state) {
            params = JSON.parse(this.$stateParams.state);
        }
        this.$state.go(this.$stateParams.prevState, params);
    },

    /**
     * Navigate to the booking edit page.
     * Passes the current booking ID and state parameters to the edit page.
     */
    editBooking() {
        this.$state.go('internal.editbooking', {
            id: this.item.Id,
            prevState: 'internal.booking-details',
            state: JSON.stringify(this.$stateParams)
        });
    },

    /**
     * Load the booking data for a given booking ID.
     * Fetches the booking details from the VehicleBookingService and assigns it to the controller's item property.
     *
     * @param {string} bookingId - The ID of the booking to load.
     * @returns {Promise} - A promise that resolves when the booking data is loaded.
     */
    loadData(bookingId) {
        return this.vehicleBookingService.getVehicleBooking(bookingId)
            .finally(this.$Loading.blockUI()) // Show loading indicator.
            .then((item) => {
                this.item = item; // Assign the fetched booking data to the item property.
            }, this.$message.error); // Display an error message if the request fails.
    }
};

/**
 * Register the controller with the AngularJS module.
 */
angular.module('internal.vehiclebookings').controller('BookingDetailsController', BookingDetailsDialogController);